// antd 5 theme from the 2way design system (github.com/2waymessage/design-system).
import { theme as antdTheme } from 'antd';

const shared = {
  fontFamily: "'Afacad Flux', Arial, sans-serif",
  borderRadius: 6, // radius-button
  borderRadiusLG: 8, // radius
  colorPrimary: '#ff6a00', // accent
};

const light = {
  ...shared,
  colorPrimaryHover: '#cc5400', // accent-hover
  colorPrimaryActive: '#cc5400',
  colorLink: '#cc5400', // darker orange keeps links readable on white (4.3:1)
  colorLinkHover: '#ff6a00',
  colorText: '#000000', // text
  colorTextSecondary: '#4c4c4c', // text-secondary
  colorBorder: 'rgba(0, 0, 0, 0.15)', // border
  colorBorderSecondary: '#e8e8e8',
  colorBgLayout: '#f2f2f2', // surface-secondary
  colorBgContainer: '#ffffff', // surface
};

const dark = {
  ...shared,
  colorPrimaryHover: '#ff964c', // accent-hover (dark)
  colorPrimaryActive: '#ff964c',
  colorLink: '#ff6a00', // 6.1:1 on #191919
  colorLinkHover: '#ff964c',
  colorText: '#ffffff', // text
  colorTextSecondary: 'rgba(255, 255, 255, 0.6)', // text-secondary
  colorBorder: 'rgba(255, 255, 255, 0.2)', // border
  colorBorderSecondary: '#282828',
  colorBgLayout: '#0a0a0a', // black-darker: page behind cards
  colorBgContainer: '#191919', // surface
  colorBgElevated: '#282828', // surface-secondary
};

// The sidebar is dark in both modes.
const sidebar = {
  Menu: {
    darkItemBg: '#191919',
    darkSubMenuItemBg: '#141414',
    darkItemColor: '#b2b2b2', // neutral-light
    darkItemHoverColor: '#ffffff',
    darkItemHoverBg: 'rgba(255, 255, 255, 0.05)',
    darkItemSelectedBg: 'rgba(255, 255, 255, 0.10)', // white-a10
    darkItemSelectedColor: '#ff6a00', // accent, 6.1:1 on #191919
    itemBorderRadius: 6,
    itemMarginInline: 8,
    iconSize: 16,
    collapsedIconSize: 18,
  },
  Layout: {
    siderBg: '#191919',
    triggerBg: '#282828',
  },
};

// Embedded in Shoper Connect (always light): Shoper's font, blue accent and text colours.
const shoper = {
  ...light,
  fontFamily: "'Source Sans Pro', Arial, sans-serif",
  colorPrimary: '#3c83ec',
  colorPrimaryHover: '#135cc8',
  colorPrimaryActive: '#135cc8',
  colorLink: '#135cc8',
  colorLinkHover: '#3c83ec',
  colorText: '#2d3748',
  colorTextSecondary: '#5c657e',
  colorBgLayout: '#f3f4f8',
  borderRadius: 4,
  borderRadiusLG: 6,
};

const shoperComponents = {
  Menu: {
    ...sidebar.Menu,
    darkItemBg: '#49456c', // Shoper Connect's purple navigation
    darkSubMenuItemBg: '#403c60',
    darkItemColor: '#e1e6f3',
    darkItemSelectedColor: '#ffffff',
    darkItemSelectedBg: 'rgba(255, 255, 255, 0.12)',
  },
  Layout: {siderBg: '#49456c', triggerBg: '#403c60'},
  Button: {borderRadius: 20, controlHeight: 36, fontWeight: 600},
  Tabs: {itemSelectedColor: '#2d3748', inkBarColor: '#3c83ec'},
};

export const getDesignTheme = (mode, shoperApp = false) => (shoperApp ? {
  algorithm: antdTheme.defaultAlgorithm,
  token: shoper,
  components: shoperComponents,
} : {
  algorithm: mode === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
  token: mode === 'dark' ? dark : light,
  components: sidebar,
});
